import { render, staticRenderFns } from "./payslips_statements.vue?vue&type=template&id=bfb9918e&scoped=true"
import script from "./payslips_statements.vue?vue&type=script&lang=js"
export * from "./payslips_statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb9918e",
  null
  
)

export default component.exports